// extracted by mini-css-extract-plugin
module.exports = {"productControlButtonsDesTimer":"styles-module-productControlButtonsDesTimer--FMQYs","productHighlightButton":"styles-module-productHighlightButton--mhrdM"};